// Statyczny snapshot cennika w formacie endpointa getPrices.php.
// Używany TYLKO gdy API i cache są niedostępne — gwarancja, że cennik nigdy
// nie jest pusty. Ceny odpowiadają wersji hardcoded z lipca 2026.
// Ostatnia pozycja (ilosc_dni 17, cena 10.00) = marker dopłaty "kolejna doba".

const daysToCenniki = (prices, surcharge) =>
    [
        ...prices.map((cena, i) => ({
            cena_id: `fb-${i + 1}`,
            ilosc_dni: String(i + 1),
            cena: cena.toFixed(2),
        })),
        { cena_id: 'fb-surcharge', ilosc_dni: String(prices.length + 1), cena: surcharge.toFixed(2) },
    ];

const PRICES_FALLBACK = [
    {
        okres_id: 'fb-1',
        nazwa_okresu: 'Październik-Maj',
        domyslna: '1',
        opis: '',
        kolejnosc: '1',
        cenniki: daysToCenniki(
            [100, 100, 100, 120, 130, 140, 150, 150, 160, 170, 180, 190, 200, 210, 220, 230],
            10,
        ),
    },
    {
        okres_id: 'fb-2',
        nazwa_okresu: 'Czerwiec-Wrzesień',
        domyslna: '0',
        opis: 'MIEJSCE STANDARDOWE + TRANSFER W CENIE.',
        kolejnosc: '2',
        cenniki: daysToCenniki(
            [100, 120, 130, 140, 160, 180, 200, 200, 210, 220, 230, 240, 250, 260, 270, 280],
            10,
        ),
    },
];

export default PRICES_FALLBACK;
